<template>
  <v-form v-model="valid" ref="form">
    <v-card class="pt-3 container">
      <v-card-title>
        <span class="headline">{{$t('medical_information')}}</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col md="12" class="pb-0 pt-0">
            <v-text-field
             :label="$t('height')"
              v-model="formData.height"
              :rules="rules4"
              required
              class="sae-required"
            ></v-text-field>
          </v-col>
          <v-col md="12" class="pb-0 pt-0">
            <v-text-field
              :label="$t('weight')"
              v-model="formData.weight"
              :rules="rules4"
              required
              class="sae-required"
            ></v-text-field>
          </v-col>
          <v-col md="12" class="pb-0 pt-0">
            <v-select
              :label="$t('blood_type')"
              v-model="formData.bloodType"
              :items="bloodList"
              item-text="name"
              item-value="name"
              :rules="rules5"
              required
              class="sae-required"
            ></v-select>
          </v-col>
          <!-- <v-col md="12" class="pb-0 pt-0">
            <v-text-field
              label="Medical Test"
              v-model="formData.medicalTest"
              type="text"
              :rules="rules"
              required
              class="sae-required"
            ></v-text-field>
          </v-col>
          <v-col md="12" class="pb-0 pt-0">
            <v-text-field
              label="Medical Condition"
              v-model="formData.medicalCondition"
              type="text"
              :rules="rules"
              required
              class="sae-required"
            ></v-text-field>
          </v-col>
          <v-col md="12" class="pb-0 pt-0">
            <v-text-field
              label="Reason"
              v-model="formData.reason"
              type="text"
              :rules="rules"
              required
              class="sae-required"
            ></v-text-field>
          </v-col>-->
          <v-col md="12" class="text-center">
            <!-- <v-btn plain class="ma-2 primary--text">Cancel</v-btn> -->
            <v-btn
              color="primary"
              class="ma-2"
              :disabled="!valid"
              :loading="loading"
              @click="saveOrUpdate(formData)"
            >{{$t('save')}}</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-form>
</template>

<script>
import moment from 'moment'

export default {
  props: ['userId', 'medical'],
  name: "Medical-Checkup-List",
  data() {
    return {
      rules: [(value) => (value === 0 ? true : !!value || this.$i18n.t('required'))],
      rules2: [(value) => (value == 0 ? true : value ? value > 0 : !!value || this.$i18n.t('required'))],
      rules4: [
        v => /^[0-9.,]+$/.test(v) || this.$i18n.t('number_required'),
        (value) => (value === 0 ? true : !!value || this.$i18n.t('required'))
      ],
      rules5: [(value) => (value ? value.length == 0 ? false || this.$i18n.t('required') : true : false || this.$i18n.t('required'))],
      baseUrl: this.$store.state.baseUrl,
      valid: false,
      formData: [],
      userIdLogin: this.$store.getters.user.id,
      loading: false,
      isEdit: false,
      bloodList: [
        { id: 1, name: 'A' },
        { id: 2, name: 'A-' },
        { id: 3, name: 'A+' },
        { id: 4, name: 'B' },
        { id: 5, name: 'B-' },
        { id: 6, name: 'B+' },
        { id: 7, name: 'O' },
        { id: 8, name: 'O-' },
        { id: 9, name: 'O+' },
        { id: 10, name: 'AB' },
        { id: 11, name: 'AB-' },
        { id: 12, name: 'AB+' },
      ],
    }
  },
  methods: {
    formatTime(date) {
      return moment(date).format("Do MMMM YYYY")
    },
    costumHeader(actionId, action) {
      return { headers: { actionId, action } }
    },
    async saveOrUpdate(data) {
      if (this.isEdit) {
        this.editComponent(data)
      } else {
        this.saveComponent(data)
      }
    },
    async saveComponent(data) {
      const body = { ...data, userId: this.userId, medicalTest: '-' }
      this.loading = true
      const result = await this.$store.dispatch('saveMedical', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.$emit('reload', true)
        this.tab = 0
      }
    },
    async editComponent(data) {
      const body = { ...data, userId: this.userId, medicalTest: '-' }
      this.loading = true
      const result = await this.$store.dispatch('editMedical', body)
      this.loading = false
      if (result) {
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.$emit('reload', true)
        this.tab = 0
      }
    },
    showMessage(type, msg) {
      this.$store.dispatch('nShowMessage', { type, msg })
    },
    refreshData() {
      setTimeout(() => {
        if (this.medical) {
          this.formData = Object.assign({}, this.medical)
          this.isEdit = true
        } else {
          if (this.$refs.form && !this.isEdit) {
            this.$refs.form.reset();
          }
          this.isEdit = false
          this.formData = {}
        }
      }, 100);
    },
  },
  created() {
    this.refreshData()
  },
  watch: {
    medical() {
      this.refreshData()
    },
    userId() {
      this.refreshData()
    },
  }
}
</script>
